//LANGS LIST
export const langsList = ["fr-FR", "en-US", "de-DE", "it-IT"];

//SCHOLAR SYSTEMS
const FRANCE = {
  name: "Français",
  105: "Grande Section",
  106: "CP",
  107: "CE1",
  108: "CE2",
  109: "CM1",
  110: "CM2",
  111: "6ème",
  112: "5ème",
  113: "4ème",
  114: "3ème",
  115: "2nde",
  116: "1ère",
  117: "Terminale",
  118: "L1",
  119: "L2",
  120: "L3",
};

const BELGIUM_fr = {
  105: "3ème maternelle",
  106: "P1",
  107: "P2",
  108: "P3",
  109: "P4",
  110: "P5",
  111: "P6",
  112: "S1",
  113: "S2",
  114: "S3",
  115: "S4",
  116: "S5",
  117: "S6",
  118: "L1",
  119: "L2",
  120: "L3",
};

const UK_england = {
  105: "Year 1",
  106: "Year 2",
  107: "Year 3",
  108: "Year 4",
  109: "Year 5",
  110: "Year 6",
  111: "Year 7",
  112: "Year 8",
  113: "Year 9",
  114: "Year 10",
  115: "Year 11",
  116: "Year 12",
  117: "Year 13",
  118: "Bachelor 1",
  119: "Bachelor 2",
  120: "Bachelor 3",
};

const US = {
  105: "Kindergarten",
  106: "1st Grade",
  107: "2nd Grade",
  108: "3rd Grade ",
  109: "4th Grade",
  110: "5th Grade",
  111: "6th Grade",
  112: "7th Grade",
  113: "8th Grade",
  114: "9th Grade",
  115: "10th Grade",
  116: "11th Grade",
  117: "12th Grade",
  118: "Bachelor 1",
  119: "Bachelor 2",
  120: "Bachelor 3",
};

const DE = {
  105: "Kindergarten",
  106: "G1",
  107: "G2",
  108: "G3",
  109: "G4",
  110: "S5",
  111: "S6",
  112: "S7",
  113: "S8",
  114: "S9",
  115: "S10",
  116: "S11",
  117: "S12-13",
  118: "L1",
  119: "L2",
  120: "L3",
};

const IT = {
  105: "Kindergarten",
  106: "E1",
  107: "E2",
  108: "E3",
  109: "E4",
  110: "E5",
  111: "S6",
  112: "S7",
  113: "S8",
  114: "S9",
  115: "S10",
  116: "S11",
  117: "S12-13",
  118: "L1",
  119: "L2",
  120: "L3",
};

//SCHOLAR SYSTEMS LIST
/**
 * code : const name of ScholarList JSON (defined above),
 * codeLang : Default locale of the scholar system : use if no preferredScholarSystem is set to select default scholar system)
 */
export const scholarSystemsList = [
  {
    code: "FRANCE",
    codeLang: "fr-FR",
    name: "Français",
    levels: FRANCE,
  },
  {
    code: "BELGIUM_fr",
    codeLang: "fr-FR",
    name: "Belge",
    levels: BELGIUM_fr,
  },
  { code: "DE", codeLang: "de-DE", name: "Deutschland", levels: DE },
  { code: "IT", codeLang: "it-IT", name: "Italia", levels: IT },

  {
    code: "UK_england",
    codeLang: "en-UK",
    name: "England",
    levels: UK_england,
  },
  { code: "US", codeLang: "en-US", name: "US", levels: US },
];
